import React, { useState, useEffect } from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import LoadingSpinner from '../components/LoadingSpinner';
import { useAuth } from '../hooks/useAuth';
import { isSuper } from '../utils/roles';
import { cn } from '../utils/cn';

function AppLayout() {
  const { user, loading } = useAuth();
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Close drawer on route change (mobile)
  useEffect(() => { setOpen(false); }, [location.pathname]);

  if (loading) {
    return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}><LoadingSpinner size="lg" label="Loading…" /></div>;
  }
  if (!user) {
    // Preserve pathname + search so query-string payloads (e.g. `?intake=…`
    // on /pay-now) survive the round-trip through login/register.
    const target = `${location.pathname}${location.search || ''}`;
    return <Navigate to={`/login?from=${encodeURIComponent(target)}`} replace />;
  }

  return (
    <div className={cn('app-shell', isSuper(user.role) && 'theme-superadmin')}>
      <Sidebar user={user} isOpen={open} onClose={() => setOpen(false)} />
      <Topbar onMenu={() => setOpen(true)} />
      <main className="app-main">
        <Outlet />
      </main>
    </div>
  );
}

export default AppLayout;
